<template>
    <button type="button" :class="classAdd" @click="action">
        <span>
            <slot />
        </span>
    </button>
</template>

<script>
export default {
    name: 'ButtonDefault',
    props: {
        classAdd: {
            type: String,
            required: false,
            default: '',
        },
        handler: {
            type: String,
            required: false,
            default: '',
        },
    },
    methods: {
        action() {
            this.$emit('click');
        },
    },
};
</script>
